import { useState, useCallback } from 'react';
import { t } from 'i18next';

import { MAX_FILE_SIZE } from '@bandido/shared/constants';
import { useSnackBar } from '@frontend/features/common/components/SnackBarContext';

export const useAttachments = (initialAttachments: File[] = []) => {
  const { addToast } = useSnackBar();
  const [attachments, setAttachments] = useState<File[]>(initialAttachments);

  const handleFileChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const fileList = event.target.files;

      if (fileList && fileList.length > 0) {
        const hasLargeFile = Array.from(fileList).some((file) => file.size > MAX_FILE_SIZE);
        if (hasLargeFile) {
          addToast({
            message: t('noteEditor.errors.fileTooLarge'),
            color: 'error',
          });
          return;
        }

        setAttachments((prevAttachments) => prevAttachments.concat(Array.from(fileList)));
      }
    },
    [addToast],
  );

  const handleRemoveAttachment = useCallback((index: number) => {
    setAttachments((prevAttachments) => prevAttachments.filter((_, i) => i !== index));
  }, []);

  return {
    attachments,
    handleFileChange,
    handleRemoveAttachment,
  };
};
